<template>
    <client-page>
        <sub-visual subTab sh="About us" index="04" total="04" tabActive="위치" bg="/images/sub/visual/sv1.jpg" />

        <section class="section section--first pb-0">
            <v-container>
                <div class="tit-wrap">
                    <h2 class="tit tit--lg dot-tit">위치</h2>
                </div>

                <v-tabs grow show-arrows center-active class="v-tab--primary">
                    <v-tab to="/ko/aboutus/location/paju"><span>파주 본사</span></v-tab>
                    <v-tab to="/ko/aboutus/location/ulsan"><span>울산 지점</span></v-tab>
                    <v-tab to="/ko/aboutus/location/daesan"><span>대산 지점</span></v-tab>
                </v-tabs>
            </v-container>
        </section>

        <section class="section section--last pt-0">
            <v-container>
                <div class="h-400px h-lg-600px">
                    <div id="map" style="width:100%; height:100%;"></div>
                </div>
                <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3155.769522805796!2d126.69968569711543!3d37.72508741952576!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c8f2e9b854575%3A0x77eb09f810775aad!2z7LyA7J207JWE7J207J207Iuc7Iqk7YWc7KaIKOyjvCk!5e0!3m2!1sko!2skr!4v1675850500373!5m2!1sko!2skr" width="100%" height="600" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> -->

                <top-image tit="Contact us" image="/images/sub/aboutus/paju-img.jpg">
                    <v-row>
                        <v-col cols="12">
                            <v-row align="center">
                                <v-col cols="auto">
                                    <v-img src="/images/icon/icon-tel.png" />
                                </v-col>
                                <v-col cols="">
                                    <span>031 906 9053 / 4</span>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12">
                            <v-row align="center">
                                <v-col cols="auto">
                                    <v-img src="/images/icon/icon-mail.png" />
                                </v-col>
                                <v-col cols="">
                                    <span>info@kiesys.co.kr</span>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12">
                            <v-row align="center">
                                <v-col cols="auto">
                                    <v-img src="/images/icon/icon-address.png" />
                                </v-col>
                                <v-col cols="">
                                    <span>(10880) 대한민국 경기도 파주시 교하로 863번길 17</span>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </top-image>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import TopImage from "@/components/dumb/top-image.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        TopImage,
    },
    data() {
        return {
            map: null,
            mapCenter: { lat: 37.7249, lng: 126.7015 },
        };
    },
    mounted() {
        this.init();
        this.initMap();
        this.setMarker(this.mapCenter, "/images/icon/icon-pin.png");
    },
    methods: {
        init() {},
        initMap() {
            this.map = new google.maps.Map(document.getElementById("map"), {
                //getElementById로 map id 속성의 요소를 가져온다.
                center: this.mapCenter, //center로 할 위도, 경도를 지정한다.
                zoom: 17, //zoom size를 지정.
                maxZoom: 20,
                minZoom: 3,
                streetViewControl: true,
                mapTypeControl: true,
                fuulscreenControl: true,
                zoomControl: true,
            });
        },
        setMarker(Points, Icon) {
            //지도에 마커를 찍는 함수.
            const markers = new google.maps.Marker({
                position: Points,
                map: this.map,
                icon: Icon, //마커 이미지
                title: "케이아이이시스템즈(주)", // 마커에 마우스를 올렸을때 간략하게 표기될 설명글
            });
        },
    },
};
</script>

<style scoped></style>
